import documentIcon from '../../assets/file-icons/DOC.svg';
import imageIcon from '../../assets/file-icons/JPG.svg';
import pdfIcon from '../../assets/file-icons/PDF.svg';
import pngIcon from '../../assets/file-icons/PNG.svg';
import spreadSheetIcon from '../../assets/file-icons/PPT.svg';
import textIcon from '../../assets/file-icons/TXT.svg';
import presentationIcon from '../../assets/file-icons/XLS.svg';
import zipIcon from '../../assets/file-icons/ZIP.svg';

const fileIcon = {
  pdf: {
    name: 'pdf',
    icon: pdfIcon,
  },
  xls: {
    name: 'xls',
    icon: spreadSheetIcon,
  },
  csv: {
    name: 'csv',
    icon: spreadSheetIcon,
  },
  jpg: {
    name: 'jpg',
    icon: imageIcon,
  },
  png: {
    name: 'png',
    icon: pngIcon,
  },
  jpeg: {
    name: 'jpeg',
    icon: imageIcon,
  },
  txt: {
    name: 'txt',
    icon: textIcon,
  },
  pptx: {
    name: 'pptx',
    icon: presentationIcon,
  },
  other: {
    name: 'other',
    icon: documentIcon,
  },
  zip: {
    name: 'zip',
    icon: zipIcon,
  },
  rar: {
    name: 'rar',
    icon: zipIcon,
  },
};

export default fileIcon;
